import { Box, Typography, makeStyles } from "@material-ui/core";
import React, { FC } from "react";

import { CustomButton } from "@/components/Button";
import theme from "@/theme";

const useStyles = makeStyles(() => ({
  root: {
    margin: "0 auto",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: theme.spacing(6, 2, 4),
  },
  image: {
    width: 220,
    height: "auto",
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      width: 320,
    },
  },
  title: {
    marginBottom: theme.spacing(1.5),
    color: theme.palette.primary.main,
  },
  description: {
    marginBottom: theme.spacing(4),
    whiteSpace: "pre-line",
  },
}));

interface ContentUnavailableProps {
  title: string;
  description: string;
  imageUrl: string;
  testId: string;
  onBack?: () => void;
  backLabel: string;
}

export const ContentUnavailable: FC<ContentUnavailableProps> = ({
  title,
  description,
  imageUrl,
  testId,
  onBack,
  backLabel,
}) => {
  const classes = useStyles();
  return (
    <Box className={classes.root} data-testid={testId}>
      <img src={imageUrl} alt="" className={classes.image} />
      <Typography variant="h3" className={classes.title}>
        {title}
      </Typography>
      <Typography variant="body1" className={classes.description}>
        {description}
      </Typography>
      {onBack && (
        <CustomButton customVariant="filled" onClick={onBack}>
          {backLabel}
        </CustomButton>
      )}
    </Box>
  );
};
